export const C0002UpsetData = {
  "All Categories": {
    "total_items": 8000,
    "sets": [
      {
        "name": "Mirroring",
        "size": 4
      },
      {
        "name": "Synergy",
        "size": 9
      },
      {
        "name": "Mobility",
        "size": 21
      },
      {
        "name": "Automation",
        "size": 113
      },
      {
        "name": "Engagement",
        "size": 161
      },
      {
        "name": "Analytics",
        "size": 631
      },
      {
        "name": "Cloud Security",
        "size": 924
      },
      {
        "name": "Networking",
        "size": 1133
      },
      {
        "name": "Storage",
        "size": 1649
      },
      {
        "name": "Compute",
        "size": 3375
      }
    ],
    "intersections": [
      {
        "sets": ["Compute"],
        "size": 2692
      },
      {
        "sets": ["Storage"],
        "size": 916
      },
      {
        "sets": ["Networking"],
        "size": 649
      },
      {
        "sets": ["Cloud Security"],
        "size": 588
      },
      {
        "sets": ["Analytics"],
        "size": 528
      },
      {
        "sets": ["Engagement"],
        "size": 309
      },
      {
        "sets": ["Automation"],
        "size": 176
      },
      {
        "sets": ["Mobility"],
        "size": 172
      },
      {
        "sets": ["Synergy"],
        "size": 78
      },
      {
        "sets": ["Mirroring"],
        "size": 63
      },
      {
        "sets": ["Automation", "Engagement"],
        "size": 45
      },
      {
        "sets": ["Automation", "Cloud Security"],
        "size": 42
      },
      {
        "sets": ["Networking", "Cloud Security"],
        "size": 38
      },
      {
        "sets": ["Analytics", "Cloud Security"],
        "size": 37
      },
      {
        "sets": ["Engagement", "Cloud Security"],
        "size": 34
      },
      {
        "sets": ["Compute", "Storage", "Networking"],
        "size": 26
      },
      {
        "sets": ["Networking", "Storage"],
        "size": 21
      },
      {
        "sets": ["Engagement", "Analytics"],
        "size": 18
      },
      {
        "sets": ["Compute", "Networking", "Cloud Security"],
        "size": 14
      },
      {
        "sets": ["Engagement", "Networking"],
        "size": 13
      },
      {
        "sets": ["Storage", "Cloud Security"],
        "size": 11
      },
      {
        "sets": ["Automation", "Networking"],
        "size": 11
      },
      {
        "sets": ["Storage", "Analytics"],
        "size": 10
      },
      {
        "sets": ["Networking", "Analytics"],
        "size": 8
      },
      {
        "sets": ["Engagement", "Storage"],
        "size": 7
      },
      {
        "sets": ["Automation", "Analytics"],
        "size": 7
      },
      {
        "sets": ["Compute", "Storage"],
        "size": 7
      },
      {
        "sets": ["Compute", "Networking"],
        "size": 7
      },
      {
        "sets": ["Compute", "Cloud Security"],
        "size": 6
      },
      {
        "sets": ["Compute", "Analytics"],
        "size": 6
      },
      {
        "sets": ["Automation", "Storage"],
        "size": 6
      },
      {
        "sets": ["Compute", "Engagement"],
        "size": 5
      },
      {
        "sets": ["Networking", "Engagement", "Cloud Security"],
        "size": 5
      },
      {
        "sets": ["Storage", "Networking", "Cloud Security"],
        "size": 5
      },
      {
        "sets": ["Engagement", "Analytics", "Cloud Security"],
        "size": 5
      },
      {
        "sets": ["Compute", "Automation"],
        "size": 5
      },
      {
        "sets": ["Compute", "Storage", "Analytics"],
        "size": 5
      }
    ]
  }
};

// Helper function to get data by category
export const getC0002UpsetDataByCategory = (category) => {
  return C0002UpsetData[category] || C0002UpsetData["All Categories"];
};

// Get list of all available categories
export const getCategories = () => {
  return Object.keys(C0002UpsetData);
};